module.exports = __webpack_public_path__ + "media/images/MyGolana-a1465f8a6177252925dd86396dc20373.png";